module.exports = __webpack_public_path__ + "media/images/niq-account-ef1d0838e8779f273be8227f9b96d8c4.svg";